export const ACCESSING = 'User accessing'

export const NETWORK_ERROR = 'Network Error'

export const DOCTOR_LOGGING_IN = 'Doctor logging in'
export const DOCTOR_LOG_IN_SUCCESS = 'Doctor successfully logged in'
export const DOCTOR_LOG_IN_ERROR = 'Doctor log in failed'
